import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * Class-name combiner (shadcn convention, PRO-0260 D2). `clsx` resolves
 * conditional class lists; `tailwind-merge` de-duplicates conflicting Tailwind
 * utilities so a caller-supplied `className` can override a primitive's default.
 *
 * Registers the theme max-width tokens `narrow`, `shell`, and `wide`
 * (`tailwind.config.ts`) on the `max-w` group so overrides resolve (BUG-0040).
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'max-w': [{ 'max-w': ['narrow', 'shell', 'wide'] }],
    },
  },
});

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
